<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableTemplates ref="table" :show-title="true"></TableTemplates>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="createItem()" color="primary">Neu erstellen</v-btn>
    </v-col>
  </v-row>
</template>


<script>
//import Vue from 'vue'
import TableTemplates from "../tables/TableTemplates";
import Vue from "vue";

export default {
  name: 'Templates',
  components: {TableTemplates},
  data() {
    return {}
  },
  methods: {
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$apiTemplate.create({}, this.onItemCreated)
    },
    onItemCreated: function (newItem) {
      console.log('onItemCreated', newItem)
      this.$router.push('/Templates/' + newItem.guid)
    }
  },
  mounted() {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
